<template>
  <div>
    <button v-if="active && !playing" class="video__play" @click="play" aria-label="play">
      <img :src="assetPath + 'play-button.png'" alt="">
    </button>
    <div class="video">
      <transition-group name="fade">
        <video :autoplay="playing" v-if="windowWidth >= 769 && active" :key="file + 'desktop'" class="video__element video__element--desktop" ref="video" :muted="!audioState" playsinline preload="auto" @ended="videoOver" :poster="assetPath + poster" :src="videoPath + '/Campaigns/ocs/videos/' + file" type="video/mp4">
          Sorry, your browser doesn't support embedded videos.
        </video>
        <video :autoplay="playing" v-if="windowWidth < 769 && active" :key="file + 'mobile'" class="video__element video__element--mobile" ref="video" :muted="!audioState" playsinline preload="auto" @ended="videoOver" :poster="assetPath + posterMobile" :src="videoPath + '/Campaigns/ocs/videos/' + fileMobile" type="video/mp4">
          Sorry, your browser doesn't support embedded videos.
        </video>
      </transition-group>
      <div class="video-controls">
        <button v-if="active && pageMode != 'suppliers'" class="skip" @click="skip">Skip</button>
        <button v-if="active" class="audio-status" @click="audio">
          <span v-if="audioState" :aria-label="`${audioLabel} Audio`">
            <AudioOn />
          </span>
          <span v-if="!audioState" :aria-label="`${audioLabel} Audio`">
            <AudioOff />
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { pageMode } from './../mixins/pageMode.js'
import { assetPath } from './../mixins/assetPath.js'
import { videoPath } from './../mixins/videoPath.js'
import { vueWindowSizeMixin } from 'vue-window-size';
import AudioOn from '@/assets/icons/volume-2.svg'
import AudioOff from '@/assets/icons/volume-x.svg'

export default {
  name: 'Video',
  components: {
    AudioOn,
    AudioOff
  },
  data() {
    return {
      finished: false,
      playing: true
    }
  },
  props: {
    // started: {
    //   type: Boolean,
    //   default: false
    // },
    index: {
      type: Number,
      default: -1
    },
    file: {
      type: String,
      default: ""
    },
    poster: {
      type: String,
      default: ""
    },
    fileMobile: {
      type: String,
      default: ""
    },
    posterMobile: {
      type: String,
      default: ""
    }
  },
  computed: {
    active() {
      return this.$store.state.active.index === this.index
    },
    audioLabel() {
      return this.audioState ? 'Mute' : 'Play'
    },
    audioState() {
      return this.$store.getters.audioState
    },
  },
  mounted () {
    // this.getState()
  },
  onBeforeUnmount() {
    this.$refs.video.stop()
    this.playing = false
  },
  methods: {
    videoOver() {
      // console.log('videoOver')
      if (this.pageMode === 'suppliers') {
        this.$store.dispatch('startSupplier')
      } else {
        this.$store.dispatch('advanceTimeline')
      }
      this.playing = false
      this.$refs.video.fastSeek(0) // when the timeline is only this, lets just reset the video
    },
    audio() {
      // eslint-disable-next-line
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: 'OCS Engagement',
          eventAction: 'click',
          eventLabel: 'Toggle Audio | ' + this.file,
        });
      }
      this.$store.dispatch('toggleAudio')
    },
    skip() {
      // eslint-disable-next-line
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: 'OCS Engagement',
          eventAction: 'click',
          eventLabel: 'Skip Video | ' + this.file,
        });
      }
      this.$store.dispatch('advanceTimeline')
    },
    play() {
      // eslint-disable-next-line
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: 'OCS Engagement',
          eventAction: 'click',
          eventLabel: 'Play Video | ' + this.file,
        });
      }
      this.playing = true
      this.$refs.video.play()
    }
  },
  mixins: [pageMode, assetPath, videoPath, vueWindowSizeMixin]
}
</script>

<style lang="scss">
  .video {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: 0;
    padding: 0;
    pointer-events: none;
    video {
      // display: block;
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
  .video__element {

  }
  // .video__element--desktop {
  //   display: none;
  //   @include breakpoint(large) {
  //     display: block;
  //   }
  // }
  // .video__element--mobile {
  //   display: block;
  //   @include breakpoint(large) {
  //     display: none;
  //   }
  // }

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.video__play {
  position: absolute;
  top: calc(50% - 56.945px);
  left: calc(50% - 56.945px);
  width: 113.89px;
  height: 113.89px;
  padding: 0;
  background-color: transparent;
  transform: scale(1);
  z-index: map-get($z, 10);
  transition: transform 200ms ease;
  &:hover {
    transform: scale(1.1);
  }
}
.video-controls {
  display: flex;
  position: absolute;
  right: 1em;
  bottom: 1em;
  z-index: map-get($z, 10);
  pointer-events: all;
  span {

  }
}
.skip {
  padding: 0;
  background-color: transparent;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-radius: 0;
  text-shadow: 1px 1px 3px rgba(0,0,0,0.666);
}
.audio-status {
  background-color: transparent;
  svg {
    width: 37px;
    height: auto;
    overflow: visible;
    path {
      filter: drop-shadow(1px 1px 2px rgba(0,0,0,0.666));
    }
  }
}

</style>